module.exports = __webpack_public_path__ + "img/annotation-insert.790992ab.svg";